module.exports = __webpack_public_path__ + "img/heart.da8dfceb.svg";